<div class="p-3 p-card surface-ground">
  <div class="flex align-items-center gap-2 text-xs mb-3">
    <i class="fas fa-lightbulb text-primary"></i>
    <span class="text-sm">Visuelle Übersicht Ihrer Auswahl</span>
  </div>

  <div class="flex flex-column gap-2">
    <!-- Focus (Fixiert) -->
    <div
      class="flex gap-3 align-items-center min-w-5rem surface-0 border-1 surface-border py-2 pl-3 pr-2 border-round">
      <div class="visual-label">
        <i class="fas fa-lock text-xs"></i>
        <span>Fixiert (1 Wert):</span>
      </div>
      <div
        class="visual-value focus border-round flex gap-2 font-bold flex-1 p-2 align-items-center justify-content-between text-sm">
        <i class="-m-2" [class]="getFocusLabel(true)"></i>
        {{ getFocusLabel() }}
      </div>
    </div>

    <!-- X-Axis or Group -->
    <div
      class="flex gap-3 align-items-center min-w-5rem surface-0 border-1 surface-border py-2 pl-3 pr-2 border-round">
      <div class="visual-label">
        <i
          [class]="
            data.isSingleAxis
              ? 'fas fa-arrows-left-right'
              : 'fas fa-layer-group'
          "></i>
        <span>{{
          data.isSingleAxis ? 'Auf der Achse:' : 'Gruppiert nach:'
        }}</span>
      </div>
      <div
        class="visual-value group border-round flex gap-2 font-bold flex-1 p-2 align-items-center justify-content-between text-sm">
        <i class="-m-2" [class]="getGroupLabel(true)"></i>
        {{ getGroupLabel() }}
      </div>
    </div>

    <!-- Y-Axis or Legend (remaining) -->
    <div
      class="flex gap-3 align-items-center min-w-5rem surface-0 border-1 surface-border py-2 pl-3 pr-2 border-round">
      <div class="visual-label">
        <i [class]="data.isSingleAxis ? 'fas fa-list' : 'fas fa-up-down'"></i>
        <span>{{
          data.isSingleAxis ? 'In der Legende:' : 'Auf 2. Achse:'
        }}</span>
      </div>
      <div
        class="visual-value remaining border-round flex gap-2 font-bold flex-1 p-2 align-items-center justify-content-between text-sm">
        <i class="-m-2" [class]="getRemainingLabel(true)"></i>
        {{ getRemainingLabel() }}
      </div>
    </div>
  </div>
</div>
